import {REQUEST_COMPLETE, REQUEST_FAILED, REQUEST_PENDING, REQUEST_UNSENT} from "../../constant/reducerConstants";

export const requestUnsent = request => {
    return {
        type: REQUEST_UNSENT,
        request
    };
};

export const requestPending = request => {
    return {
        type: REQUEST_PENDING,
        request
    };
};

export const requestComplete = request => {
    return {
        type: REQUEST_COMPLETE,
        request
    };
};

export const requestFailed = request => {
    return {
        type: REQUEST_FAILED,
        request
    };
};


// WEBPACK FOOTER //
// ./src/state/action/networkActions.js